import instance from "../../utils/instance";

class InvService {
    async getImportConfirmData(batchId) {
		return await instance.get('/crm/stock/getCacheInventory?key=' + batchId);
    }

    async submitImportConfirmData(data,batchId) {
		return await instance.post('/crm/stock/updateInventoryInit',{
			cacheKey:batchId,
			stockDataJson:data
		});
    }
}

export default new InvService();